/* assets/product-grid.js */

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.pg-wrapper').forEach(initProductGrid);
});

function initProductGrid(wrapper) {
  var grid = wrapper.querySelector('[data-product-grid]');
  var switcher = wrapper.querySelector('.view-switcher');
  var STORAGE_KEY = 'pg-view-preference';

  /* ---- View switcher ---- */
  if (grid && switcher) {
    var buttons = switcher.querySelectorAll('[data-view-btn]');

    function applyView(view) {
      grid.setAttribute('data-view', view);
      buttons.forEach(function (btn) {
        var active = btn.getAttribute('data-view-btn') === view;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      try { localStorage.setItem(STORAGE_KEY, view); } catch (e) {}
    }

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        applyView(btn.getAttribute('data-view-btn'));
      });
    });

    var saved = null;
    try { saved = localStorage.getItem(STORAGE_KEY); } catch (e) {}
    if (saved) applyView(saved);
  }

  /* ---- Quick add (AJAX Cart API) + color swatches + size popover ---- */

  function getCardVariants(card) {
    if (card._pgVariants) return card._pgVariants;
    var script = card.querySelector('[data-variant-data]');
    if (!script) return null;
    try {
      card._pgVariants = JSON.parse(script.textContent);
    } catch (e) {
      card._pgVariants = null;
    }
    return card._pgVariants;
  }

  function optionIndex(card, key) {
    var raw = card.dataset[key];
    return raw === '' || raw === undefined ? null : parseInt(raw, 10);
  }

  // When a product has no Size option, "+" should add the currently
  // selected color's variant straight away — keep its variant id in
  // sync with whichever swatch is selected.
  function syncQuickAddForColor(card) {
    var variants = getCardVariants(card);
    var quickAddBtn = card.querySelector('[data-quick-add]');
    if (!variants || !quickAddBtn) return;
    if (quickAddBtn.getAttribute('data-needs-options') === 'true') return; // has sizes, handled by popover

    var colorIdx = optionIndex(card, 'colorOptionIndex');
    var selectedColor = card.dataset.selectedColor || null;

    var match = variants.find(function (v) {
      return colorIdx === null || v.options[colorIdx] === selectedColor;
    });
    if (match) {
      quickAddBtn.setAttribute('data-variant-id', match.id);
    }
  }

  /* ---- Color-name fallback ----
     When a shop hasn't configured Shopify's native swatch color/image
     on an option value, there's no color data to read at all — the
     option is just plain text like "BLACK" or "OFF WHITE". As a
     fallback, guess a reasonable swatch color from that text itself.
     Exact matches are tried first, then the longest known color word
     found inside the name (so "RUST ORANGE" or "DARK BOTTLE GREEN"
     still resolve sensibly). Anything unrecognized just keeps the
     plain grey box rather than guessing wrong. */
  var COLOR_NAME_MAP = {
    'black': '#111111', 'white': '#ffffff', 'off white': '#f2ece0', 'off-white': '#f2ece0',
    'ivory': '#fffff0', 'cream': '#fdf6e3', 'skin': '#e8b98d', 'nude': '#e3bc9a',
    'beige': '#e8dcc8', 'tan': '#d2b48c', 'sand': '#dccb9c', 'stone': '#ccc2ab',
    'khaki': '#c3b091', 'camel': '#c19a6b', 'mocha': '#8a6240', 'coffee': '#6f4e37',
    'chocolate': '#5a3825', 'brown': '#6b4423', 'rust': '#a5432a', 'copper': '#b87333',
    'bronze': '#8c6b2f', 'terracotta': '#c1603e',
    'grey': '#8a8a8a', 'gray': '#8a8a8a', 'charcoal': '#3b3b3b', 'silver': '#c4c4c4',
    'ash': '#b2b2b2', 'steel grey': '#71797e', 'steel gray': '#71797e',
    'navy': '#1b2a4a', 'blue': '#2b4b8f', 'royal blue': '#3453a4', 'sky blue': '#8fc1e3',
    'powder blue': '#b6d4e6', 'denim': '#3b5c82', 'cobalt': '#2456a8', 'teal': '#1c7c78',
    'turquoise': '#3fc1bf', 'aqua': '#5fc9c9', 'peacock': '#0c6b6b',
    'green': '#3f7d4f', 'olive': '#6c6b34', 'bottle green': '#1f4a34', 'forest green': '#294936',
    'hunter green': '#28483a', 'mint': '#a7d8c9', 'sea green': '#3f8f77', 'emerald': '#2f7a5c',
    'jade': '#3c9a72', 'army': '#5b5f43',
    'yellow': '#e8c744', 'mustard': '#c9a32a', 'gold': '#c8a951', 'golden': '#c8a951',
    'lemon': '#e6d94e',
    'orange': '#d97f3d', 'peach': '#e8b48a', 'coral': '#e08067', 'salmon': '#e0917a',
    'red': '#a83232', 'crimson': '#9c1c2e', 'scarlet': '#a01f1f', 'maroon': '#6d1f2b',
    'wine': '#5c1f2e', 'burgundy': '#5c1f2e',
    'pink': '#dba3b3', 'blush': '#e6c2c9', 'baby pink': '#f0cdd6', 'hot pink': '#d84f8a',
    'magenta': '#a03a7a', 'fuchsia': '#a63a8f', 'rose': '#c76b83', 'rose gold': '#caa298',
    'purple': '#6a4a8a', 'violet': '#6f4d8f', 'lavender': '#b6a3c9', 'lilac': '#c3aed6',
    'mauve': '#9c7b8a', 'plum': '#6a3653', 'indigo': '#3d3467',
    'multi': '#d8d8d8', 'multicolor': '#d8d8d8', 'multi color': '#d8d8d8', 'print': '#d8d8d8'
  };

  function guessColorFromName(rawName) {
    if (!rawName) return null;
    var name = rawName.toLowerCase().trim().replace(/\s+/g, ' ');
    if (COLOR_NAME_MAP[name]) return COLOR_NAME_MAP[name];

    var bestKey = null;
    Object.keys(COLOR_NAME_MAP).forEach(function (key) {
      var escaped = key.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
      var pattern = new RegExp('\\b' + escaped + '\\b');
      if (pattern.test(name) && (!bestKey || key.length > bestKey.length)) {
        bestKey = key;
      }
    });
    return bestKey ? COLOR_NAME_MAP[bestKey] : null;
  }

  function initCardColors(card) {
    var swatchRow = card.querySelector('[data-color-swatches]');
    if (swatchRow) {
      swatchRow.querySelectorAll('.pg-card__swatch').forEach(function (swatch) {
        // Only fill in a guessed color when Shopify gave us nothing —
        // never override a real swatch color/image already set inline.
        if (!swatch.getAttribute('style')) {
          var guessed = guessColorFromName(swatch.getAttribute('data-color-value'));
          if (guessed) swatch.style.backgroundColor = guessed;
        }
      });

      var selected = swatchRow.querySelector('.pg-card__swatch.is-selected') || swatchRow.querySelector('.pg-card__swatch');
      if (selected) {
        card.dataset.selectedColor = selected.getAttribute('data-color-value');
      }
      syncQuickAddForColor(card);
    }

    var popover = card.querySelector('[data-quickadd-popover]');
    if (popover) {
      card.addEventListener('mouseleave', function () {
        popover.classList.remove('is-open');
      });
    }
  }

  wrapper.querySelectorAll('[data-product-card]').forEach(initCardColors);

  wrapper.addEventListener('click', function (e) {
    var swatchBtn = e.target.closest('[data-color-swatch]');
    if (swatchBtn) {
      var swatchCard = swatchBtn.closest('[data-product-card]');
      var row = swatchBtn.closest('[data-color-swatches]');
      row.querySelectorAll('[data-color-swatch]').forEach(function (b) {
        b.classList.remove('is-selected');
        b.setAttribute('aria-pressed', 'false');
      });
      swatchBtn.classList.add('is-selected');
      swatchBtn.setAttribute('aria-pressed', 'true');
      swatchCard.dataset.selectedColor = swatchBtn.getAttribute('data-color-value');

      var newImage = swatchBtn.getAttribute('data-color-image');
      if (newImage) {
        var primaryImg = swatchCard.querySelector('.pg-card__img--primary');
        if (primaryImg) primaryImg.src = newImage;
      }

      syncQuickAddForColor(swatchCard);
      refreshSizeAvailability(swatchCard);
      return;
    }
  });

  // Marks each size button available/unavailable for the currently
  // selected color, and attaches the matching variant id to it.
  function refreshSizeAvailability(card) {
    var popover = card.querySelector('[data-quickadd-popover]');
    var variants = getCardVariants(card);
    if (!popover || !variants) return;

    var colorIdx = optionIndex(card, 'colorOptionIndex');
    var sizeIdx = optionIndex(card, 'sizeOptionIndex');
    var selectedColor = card.dataset.selectedColor || null;

    popover.querySelectorAll('.pg-quickadd__value').forEach(function (btn) {
      var size = btn.getAttribute('data-value');
      var match = variants.find(function (v) {
        var colorOk = colorIdx === null || v.options[colorIdx] === selectedColor;
        var sizeOk = sizeIdx === null || v.options[sizeIdx] === size;
        return colorOk && sizeOk;
      });
      var available = !!(match && match.available);
      btn.classList.toggle('is-unavailable', !available);
      btn.disabled = !available;
      if (match) {
        btn.setAttribute('data-variant-id', match.id);
      } else {
        btn.removeAttribute('data-variant-id');
      }
    });
  }

  function addVariantToCart(variantId, onDone) {
    // Dawn's cart drawer (or the older cart notification popup) is a
    // custom element that knows how to render itself from the
    // cart/add.js response — but only if we ask for its sections and
    // hand the response to it. This is the same flow Dawn's own
    // product-form.js uses, so it opens the drawer exactly like a
    // normal Dawn "Add to cart" button would.
    var cartDrawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var body = { items: [{ id: variantId, quantity: 1 }] };

    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      body.sections = cartDrawer.getSectionsToRender().map(function (section) { return section.id; });
      body.sections_url = window.location.pathname;
    }

    fetch(window.Shopify && Shopify.routes && Shopify.routes.root
      ? Shopify.routes.root + 'cart/add.js'
      : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        document.dispatchEvent(new CustomEvent('cart:updated'));
        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          cartDrawer.classList.remove('is-empty');
          cartDrawer.renderContents(data);
        }
        onDone(true);
      })
      .catch(function () {
        onDone(false);
      });
  }

  function closeAllPopovers() {
    wrapper.querySelectorAll('[data-quickadd-popover]').forEach(function (p) {
      p.classList.remove('is-open');
    });
  }

  wrapper.addEventListener('click', function (e) {
    /* Open the size box / add straight to cart */
    var quickAddBtn = e.target.closest('[data-quick-add]');
    if (quickAddBtn) {
      if (quickAddBtn.getAttribute('data-needs-options') === 'true') {
        closeAllPopovers();
        var card = quickAddBtn.closest('[data-product-card]');
        var popover = card && card.querySelector('[data-quickadd-popover]');
        if (popover) {
          popover.classList.add('is-open');
          refreshSizeAvailability(card);
        }
        return;
      }

      var variantId = quickAddBtn.getAttribute('data-variant-id');
      if (!variantId) return;

      quickAddBtn.disabled = true;
      addVariantToCart(variantId, function (success) {
        if (success) quickAddBtn.classList.add('is-added');
        setTimeout(function () {
          quickAddBtn.classList.remove('is-added');
          quickAddBtn.disabled = false;
        }, 1500);
      });
      return;
    }

    /* Close the size box */
    if (e.target.closest('[data-quickadd-close]')) {
      var openPopover = e.target.closest('[data-quickadd-popover]');
      if (openPopover) openPopover.classList.remove('is-open');
      return;
    }

    /* Tap a size — adds that variant to cart right away */
    var sizeBtn = e.target.closest('.pg-quickadd__value');
    if (sizeBtn && !sizeBtn.disabled) {
      var sizeVariantId = sizeBtn.getAttribute('data-variant-id');
      if (!sizeVariantId) return;

      var originalLabel = sizeBtn.textContent;
      sizeBtn.disabled = true;
      sizeBtn.classList.add('is-selected');

      addVariantToCart(sizeVariantId, function (success) {
        var sizePopover = sizeBtn.closest('[data-quickadd-popover]');
        if (success) {
          sizeBtn.textContent = 'Added';
          setTimeout(function () {
            if (sizePopover) sizePopover.classList.remove('is-open');
            sizeBtn.textContent = originalLabel;
            sizeBtn.classList.remove('is-selected');
            sizeBtn.disabled = false;
          }, 900);
        } else {
          sizeBtn.textContent = 'Try again';
          sizeBtn.disabled = false;
          sizeBtn.classList.remove('is-selected');
        }
      });
      return;
    }
  });

  // Close popover when clicking outside a card
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-product-card]')) return;
    closeAllPopovers();
  });

  /* ---- Infinite scroll (AJAX pagination) ---- */
  var isLoadingMore = false;
  var loadMoreObserver = null;

  function loadNextPage(sentinel) {
    var nextUrl = sentinel.getAttribute('data-next-url');
    if (!nextUrl || isLoadingMore) return;

    isLoadingMore = true;
    var spinner = sentinel.querySelector('[data-load-more-spinner]');
    if (spinner) spinner.removeAttribute('hidden');

    fetch(nextUrl)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.querySelector('[data-product-grid]');
        var newWrap = doc.querySelector('[data-load-more-wrap]');
        if (!newGrid) return;

        // Move in the newly-fetched product cards
        var newCards = newGrid.querySelectorAll('.pg-card');
        newCards.forEach(function (card) {
          grid.insertBefore(card, sentinel);
          initCardColors(card);
        });

        // Swap in the next page's sentinel (or remove it if this was the last page)
        if (loadMoreObserver) loadMoreObserver.unobserve(sentinel);
        sentinel.remove();
        if (newWrap) {
          grid.appendChild(newWrap);
          if (loadMoreObserver) loadMoreObserver.observe(newWrap);
        }
      })
      .finally(function () {
        isLoadingMore = false;
      });
  }

  var initialSentinel = wrapper.querySelector('[data-load-more-wrap]');
  if (initialSentinel && 'IntersectionObserver' in window) {
    // rootMargin loads the next page a bit before the sentinel is
    // actually on screen, so new products are ready by the time the
    // person scrolls to the bottom rather than popping in late.
    loadMoreObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) loadNextPage(entry.target);
      });
    }, { rootMargin: '600px 0px' });

    loadMoreObserver.observe(initialSentinel);
  } else if (initialSentinel) {
    // No IntersectionObserver support: fall back to loading the rest
    // immediately rather than leaving products unreachable.
    loadNextPage(initialSentinel);
  }
}
